<script lang="ts">
	import type { PLItem } from '#lib/types/types.js';

	import Loading from '#lib/components/loading/Loading.svelte';
	import { Github, MoveRight } from '@lucide/svelte';

	const { item }: { item: PLItem } = $props();

	let loading = $state(false);
	let thumbnail = $state<string>();

	$effect(() => {
		const loadThumbnail = async () => {
			loading = true;
			thumbnail = (await import(`../../images/${item.thumbnail ?? 'cs'}.jpg`)).default;
			loading = false;
		};
		loadThumbnail();
	});
</script>

<div class="card border">
	<div class="flex h-48 w-full items-center justify-center">
		{#if loading}
			<div class="flex h-48 w-full items-center justify-center text-neutral-600 dark:text-neutral-400">
				<Loading />
			</div>
		{:else}
			<img
				class="h-48 w-full border-b object-cover"
				src={thumbnail || ''}
				alt="loading"
				loading="lazy"
				decoding="async"
			/>
		{/if}
	</div>
	<div class="px-6 pb-4 pt-6">
		<div class="mb-2 flex items-center">
			<h3 class="flex items-center text-xl font-bold">
				{item.title}
			</h3>
			{#if item.ongoing}
				<span
					class="ml-2 rounded-full border border-transparent bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-700 dark:border-yellow-400/25 dark:bg-yellow-500/15 dark:text-yellow-200"
					>Ongoing</span
				>
			{:else}
				<span class="ml-2 rounded-full border border-transparent bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700 dark:border-green-400/25 dark:bg-green-500/15 dark:text-green-200"
					>Finished</span
				>
			{/if}
		</div>
		<p class="mb-2 text-sm font-normal text-neutral-700 dark:text-neutral-300">{item.description}</p>
		<div>
			{#each item.tags as tag}
				<div class="tag">{tag}</div>
			{/each}
		</div>
		<div class="card-link-container">
			{#each item.links as link}
				<div class="card-link">
					<a href={link.link} target="_blank" rel="noreferrer" class="flex items-center">
						{#if link.type === 'Github'}
							<Github class="h-6 w-6" />
						{:else}
							{link.type}
							<MoveRight class="ml-2 h-4 w-4" />
						{/if}
					</a>
				</div>
			{/each}
		</div>
	</div>
</div>
